"use client";

interface Section {
  title: string;
  lines: string[];
  bullets: string[];
  subs: { title: string; lines: string[] }[];
}

const HIDDEN = ["関連"];
const EMPTY = ["未設定", "【特になし】", "特になし"];

function plain(line: string): string {
  return line.replace(/\[([^\]]+)\]\([^)]*\)/g, "$1");
}

function parse(text: string): Section[] {
  const sections: Section[] = [];
  let section: Section | null = null;
  let sub: Section["subs"][number] | null = null;
  for (const raw of text.split("\n")) {
    const line = raw.trim();
    if (line === "" || line.startsWith("# ")) continue;
    if (line.startsWith("## ")) {
      section = { title: line.slice(3), lines: [], bullets: [], subs: [] };
      sub = null;
      sections.push(section);
      continue;
    }
    if (!section) continue;
    if (line.startsWith("### ")) {
      sub = { title: line.slice(4), lines: [] };
      section.subs.push(sub);
      continue;
    }
    const body = line.startsWith("- ") ? plain(line.slice(2)) : plain(line);
    if (sub) sub.lines.push(body);
    else if (line.startsWith("- ")) section.bullets.push(body);
    else section.lines.push(body);
  }
  return sections.filter((one) => !HIDDEN.includes(one.title));
}

/**
 * プロフィールのタブ。人物のメインの md を、見出しと箇条書きの印を出さずに並べる。
 * md の順に節を並べ、文の節は段落、箇条書きの節は 1 項ずつの行、小見出しの節は名と値の行にする。中身が未設定の節は出さない
 */
export default function PlayProfile({ text }: { text: string }) {
  const sections = parse(text).filter((one) => !(one.subs.length === 0 && [...one.lines, ...one.bullets].every((line) => EMPTY.includes(line))));
  return (
    <div className="pl-prof">
      {sections.map((one) => (
        <section className="pl-prof-sec" key={one.title}>
          <h3>{one.title}</h3>
          {one.lines.map((line, index) => (
            <p className="pl-prof-p" key={index}>
              {line}
            </p>
          ))}
          {one.bullets.length > 0 ? (
            <ul className="pl-prof-items">
              {one.bullets.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
          ) : null}
          {one.subs.length > 0 ? (
            <dl className="pl-prof-pairs">
              {one.subs.map((pair) => (
                <div key={pair.title}>
                  <dt>{pair.title}</dt>
                  <dd>{pair.lines.join("\n")}</dd>
                </div>
              ))}
            </dl>
          ) : null}
        </section>
      ))}
    </div>
  );
}
